/* @flow */
import React, { useCallback } from 'react';

import Styled from './styled';
import Icon from '../Icon';
import Spinner from '../Spinner';

type Props = {
  className?: any,
  disabled?: boolean,
  icon: string,
  isToggle?: boolean,
  label?: string,
  loading?: boolean,
  onClick?: (event: any) => any,
  size?: 'default' | 'inherit' | 'large' | 'small',
  style?: any,
  tooltip?: string,
};

export default ({
  className,
  disabled = false,
  icon,
  isToggle = false,
  label,
  loading = false,
  onClick,
  size,
  style,
  tooltip,
}: Props): React$Element<any> => {
  if (loading) {
    return <Spinner />;
  }
  const handleClick = useCallback(
    (event: any) => {
      if (disabled && !isToggle) {
        return;
      }
      onClick && onClick(event);
    },
    [disabled, isToggle, onClick]
  );
  return (
    <Styled.Container className={className} style={style} onClick={handleClick}>
      <Styled.IconOverlay disabled={disabled} isToggle={isToggle}>
        <Icon tooltip={tooltip} name={icon} disabled={disabled} size={size} />
      </Styled.IconOverlay>
      {label && <Styled.IconLabel>{label}</Styled.IconLabel>}
    </Styled.Container>
  );
};
